import React, { useState, useEffect } from 'react';
import Layout from "components/Layout";
import SocialAuth from 'components/SocialAuth';
import FormLogin from 'components/FormLogin';
import ValidSession from 'components/ValidSession';
import SessionFactory from 'factories/Session';
import TermPolCheckbox from 'components/TermPolCheckbox';
import MsgError from 'components/MsgError';

const PageFacebook = () => {

    const [loadData, setLoadData] = useState(false);
    const [dataPage, setDataPage] = useState({});
    //erick
    const[formLoginEmailVisible,setFormLoginEmailVisible]=useState(false);
    
    const[legalSocial,setLegalSocial]= useState ([false,false,false]);
    const[legal,setLegal]= useState ([0,0,0]);
    const[termPolCheckedLogin,setTermPolCheckedLogin] = useState(true);
    const[visibleLegalSocialTooltip,setVisibleLegalSocialTooltip]= useState ([false,false,false]);
    const[msg,setMsg]= useState(0); //necesary  to function tooltip


    const handleTool =()=>{
       
        setMsg(msg+1)  //necesary  to function tooltip
        if(legalSocial[0]==false){

        let dataVisibleLegalSocialTooltip =visibleLegalSocialTooltip;  
        dataVisibleLegalSocialTooltip[0]=true;
        setVisibleLegalSocialTooltip(dataVisibleLegalSocialTooltip);

        }
        if(legalSocial[1]==false){
        let dataVisibleLegalSocialTooltip =visibleLegalSocialTooltip;  
        dataVisibleLegalSocialTooltip[1]=true;
        setVisibleLegalSocialTooltip(dataVisibleLegalSocialTooltip);
        }
       /*  if(visibleLegalSocialTooltip[2]==false){
            let dataVisibleLegalSocialTooltip =visibleLegalSocialTooltip;  
            dataVisibleLegalSocialTooltip[2]=true;
            setVisibleLegalSocialTooltip(dataVisibleLegalSocialTooltip);
        } */
      
    }

    
    
    const visibleForm = ()=>{
        //visible FormLoginEmail
        setLegalSocial([false,false,false]); //inicio legalsocial Tooltip 
        setLegal([0,0,0]) // inicio legal bd
        setTermPolCheckedLogin(true);
        setFormLoginEmailVisible(!formLoginEmailVisible);
    
    }
        const handleDisButtSocAut = (e)=> {
    
        //
        let dataLegalSocial=legalSocial;  //activate buttons social
        let dataLegal = legal;  //send authSocial
        let dataTooltip = visibleLegalSocialTooltip; //data tooltip
        if(e.target.id =="terminos"){
            dataLegalSocial[0]=e.target.checked;
            dataLegal[0] = e.target.checked?1:0
            setLegalSocial(dataLegalSocial);

            //tooltip
            dataTooltip[0]=(!e.target.checked);
            setVisibleLegalSocialTooltip(dataTooltip);
            setMsg(msg+1); //necesary  to function tooltip
            //
        }
        if(e.target.id =="politica"){
            dataLegalSocial[1]=e.target.checked;
            dataLegal[1] = e.target.checked?1:0
            setLegalSocial(dataLegalSocial);

            //tooltip
            dataTooltip[1]=(!e.target.checked);
            setVisibleLegalSocialTooltip(dataTooltip);
            setMsg(msg+1); //necesary  to function tooltip
            //
        }
       /*  if(e.target.id =="data-protection"){
            dataLegalSocial[2]=e.target.checked;
            dataLegal[2] = e.target.checked?1:0
            setLegalSocial(dataLegalSocial);
        } */
        let valueCheck= legalSocial;
    if(valueCheck[0]==true & valueCheck[1]==true){
      
        setTermPolCheckedLogin(false);
    }
    if(valueCheck[0]==false || valueCheck[1]==false){
       
       
        setTermPolCheckedLogin(true);
    }
    setLegal(dataLegal)

        //
    }
      
        //end erick
    useEffect(() => {
        setDataPage({ session: SessionFactory.validation() });
        setLoadData(true);
    }, []);

    return (
        <div className="login">
            {loadData && <ValidSession dataSession={dataPage.session?null:{any:true}} customPath={'/home'}/>}
            <Layout showBanner={false} showContent={loadData && !dataPage.session? true : false}>
                <section className="authentication">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-10 ml-lg-auto mr-lg-auto">
                                <div className="row">
                                    <div className="col-12">
                                        <h2 className="text-center red mt-4 mb-4">Iniciar sesión</h2>
                                        <p className="text-center mt-4 red-dark">Puedes ingresar con tu cuenta de Metro.pe</p>
                                        <div className="col-12 col-lg-5 ml-lg-auto mr-lg-auto mt-lg-5 mt-3 ">
                                        <SocialAuth actionCall="login" disablebuttons={termPolCheckedLogin} legal={legal} handleTool={handleTool} showFacebook={true}/>
                                        <button className="btn btn-conect-social-ingresar mt-3 btn-default btn-sm no-hover hover-wong btn-block" onClick={visibleForm} disabled={false}>Ingresar con Email y Contraseña</button>
                                        </div>
                                        {
                                        formLoginEmailVisible?
                                        <div className="col-12 col-lg-5 ml-lg-auto mr-lg-auto mt-lg-5 mt-5">
                                            <FormLogin />
                                        </div>
                                        :
                                        
                                        <div className="col-lg-8  ml-lg-auto mr-lg-auto mt-lg-4 mt-3">
                                    

                                            <div className="col-lg-11 ml-lg-auto mr-lg-auto mt-lg-4 mt-3  ">
                                                <div className="col-lg-12 ml-lg-auto mr-lg-auto mt-lg- mt-3 ">
                                                {visibleLegalSocialTooltip[0] &&<MsgError msg="*obligatorio*" />}
                                                </div>
                                                <div className="col-lg-9 ml-lg-auto mr-lg-auto mt-lg- mt-3">
                                                <TermPolCheckbox textId = "terminos" handlegetValueCheked={handleDisButtSocAut} />
                                                </div>
                                            </div>
                                       
                             
                                            <div className="col-lg-11 ml-lg-auto mr-lg-auto mt-lg-4 mt-3">
                                                <div className="col-lg-12 ml-lg-auto mr-lg-auto mt-lg- mt-3">
                                                {visibleLegalSocialTooltip[1] &&<MsgError msg="*obligatorio*"  />}
                                                </div>
                                                <div className="col-lg-9 ml-lg-auto mr-lg-auto mt-lg- mt-3">
                                                <TermPolCheckbox textId = "politica" handlegetValueCheked={handleDisButtSocAut} />
                                                </div>
                                            </div>
                                       
                                       
                                      {/*  <div className="col-12 col-lg-9 ml-lg-auto mr-lg-auto mt-lg-4 mt-3">
                                       {visibleLegalSocialTooltip[2] &&<MsgError msg="*opcional*"  />}
                                       <TermPolCheckbox textId = "data-protection" handlegetValueCheked={handleDisButtSocAut} />
                                       
                                       </div> */}
            
                                         
                                   </div>
                                       
                                       
                                        } 
                                    </div>   
                                </div>
                                <div className="row footer-links">
                                    <div className="col-12 col-lg-4 ml-lg-auto mr-lg-auto mt-lg-5 mt-3">
                                        <p className="legend-login text-center">¿No tiene una cuenta? <a href="/register">Regístrese</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    )
};

export default PageFacebook;
